import yup, { enumValidator, integerPositiveValidator } from '~/utils/validators.yup';
import { REVEALED_PHASE_OPTIONS } from '~/config/constants';

export const restrictionDetailRule = {
    restrictionDetail: yup.object().shape({
        phaseRestrictionOptions: yup.array().of(enumValidator(REVEALED_PHASE_OPTIONS)),
        minimumHpValue: integerPositiveValidator,
        minimumPointValue: integerPositiveValidator,
    }),
};
